<template>
    <div class="">
        <div class="centerbox clearfix" id="teacherinfo">
            <img src="http://192.168.15.150:8000/group2/M00/00/00/wKgPmV1jyWWALcdyAATF4sr_TAQ324.png" width="390" height="300" class="fl">
            <div class="fl jsxq_box">
                <p class="jsxq_name">{{teacher.teacherName}}</p>
                <p class="jsxq_js">{{teacher.teacherJianjie}}</p>
                <p class="jsxq_wb"><span>讲授课程：</span>{{teacher.teachCourse}}</p>
                <p class="jsxq_wb"><span>所属机构：</span>{{teacher.orgName}}</p>
            </div>
        </div>

        <div class="mstd_box2">
            <span>李明</span>老师的课程
        </div>
            <div class="jsmid_box clearfix">
                <div class="mstd-box" id="teachercourse">
                    <a class="mstd_nr fl">
                    <p class="img_m"><img src="http://192.168.15.150:8000/group2/M00/00/00/wKgPmV1jyWWALcdyAATF4sr_TAQ324.png"></p>
                    <p class="sp_bt">ACCA（F1)：会计师与企业</p>
                    <p class="sp_js2">北京语言大学继续教育学院</p>
                    <p class="sp_js2">讲师：{{teacher.teacherName}}</p>
                    <p class="sp_js2 clearfix">
                    <span class="fl">
                    授课类型：直播<br>
                    课时：5
                    </span>
                    </p>
                    </a>

                </div>
                <div class="mstd-box" id="1">
                    <a class="mstd_nr fl">
                        <p class="img_m"><img src="http://192.168.15.150:8000/group2/M00/00/00/wKgPmV1jyWWALcdyAATF4sr_TAQ324.png"></p>
                        <p class="sp_bt">ACCA（F1)：会计师与企业</p>
                        <p class="sp_js2">北京语言大学继续教育学院</p>
                        <p class="sp_js2">讲师：{{teacher.teacherName}}</p>
                        <p class="sp_js2 clearfix">
                    <span class="fl">
                    授课类型：直播<br>
                    课时：5
                    </span>
                        </p>
                    </a>

                </div>
            </div>


    </div>
</template>

<script>
    export default {
        name: "",
        data() {
            return {
                teacher : {},
            }
        },
        created() {
            this.teacher = this.$route.params
        },
    }
</script>

<style scoped>
    .mstd-box {
        margin-right: 20px;
        width: 300px;
        float: left;
    }
    .mstd_ljgm {
        color: #fff;
        padding: 4px 12px 4px 12px;
        display: inline-block;
        background: #d28a30;
        border-radius: 5px;
        margin-top: 10px;
    }
    .fr {
        float: right;
        display: inline;
    }
    .fl {
        float: left;
        display: inline;
    }

    .sp_bt {
        font-size: 16px;
        padding: 10px 0 0 10px;
        /* margin-left: 10px;
        margin-top: 10px; */
    }

    .sp_js {
        padding: 10px 0 10px 10px;
        /* margin-left: 10px;
        margin-top: 10px; */
        color: #8a8a8a;
        line-height: 26px;
    }

    .sp_js2 {
        padding-left: 10px;
        color: #8a8a8a;
        line-height: 26px;
        font-size: 14px;
    }
    .ssjg_nr:hover,.ssnr_nr:hover,.mstd_nr:hover,.wdsc_nr:hover,.zbkc_nr:hover,.stkc_nr:hover,.ckjr_nr:hover{
        background: #f0f0f0;
    }
    .ssjg_nr p:first-of-type,
    .ssnr_nr p:first-of-type,
    .mstd_nr p:first-of-type,
    .wdsc_nr p:first-of-type,
    .ckjr_nr p:first-of-type,
    .zbkc_nr p:first-of-type,
    .stkc_nr p:first-of-type {
        width: 212px;
        height: 134px;
        overflow: hidden;
    }
    .centerbox {
        /*padding-bottom:40px;*/
        padding-left: 50px;
        position: relative;
    }
    .clearfix:after {
        content: "";
        display: block;
        clear: both;
        height: 0;
        visibility: hidden;
    }


    .ym_box3 {
        width: 1200px;
        margin-bottom: 80px;
    }

    .jsxq_box {
        width: 720px;
        height: 290px;
        margin-left: 20px;
        margin-bottom: 55px;
    }

    .jsxq_name {
        font-size: 24px;
        color: #7a7a7a;
        margin-top: 10px;
    }

    .jsxq_js {
        font-size: 14px;
        color: #7a7a7a;
        line-height: 26px;
        margin-top: 30px;
        height: 140px;
        overflow: auto;
        overflow-x: hidden;
    }

    .jsxq_wb {
        color: #7a7a7a;
        margin-top: 10px;
        font-size: 18px;
    }

    .jsxq_wb span {
        color: #fff;
        background: #61a4f2;
        padding: 4px 12px 4px 12px;
        display: inline-block;
        margin-right: 10px;
    }

    .jsxq_kc {
        width: 1130px;
        height: 50px;
        line-height: 50px;
        color: #7cc3fa;
        border-bottom: 1px solid #eaeaea;
        margin: 0 auto;
    }

    .jsmid_box {
        background: #fff;
        padding-left: 50px;
        margin-top: 10px;
    }
    .mstd_box {
        padding: 30px 0 30px 0;
        position: relative;
        z-index: 10;
    }

    .mstd_box2 {
        background: #d7d6d6;
        height: 80px;
        line-height: 80px;
        font-size: 20px;
        padding-left: 50px;
    }
</style>